import { PollDetailPage } from '@/components/governance/poll-detail-page'

export function OperationsPollDetail() {
  return <PollDetailPage basePath="/operations/polls" />
}
